interface DesktopStorageBridge {
  getItem(key: string): string | null;
  setItem(key: string, value: string): boolean;
  removeItem(key: string): boolean;
}

declare global {
  interface Window {
    gameDesktop?: {
      isDesktop: boolean;
      platform: string;
      storage: DesktopStorageBridge;
      toggleFullscreen(): Promise<boolean>;
      paths(): Promise<{ userData: string; saves: string }>;
    };
  }
}

const memoryStorage = new Map<string, string>();

export const gameStorage = {
  getItem(key: string): string | null {
    if (typeof window === "undefined") return memoryStorage.get(key) ?? null;
    return window.gameDesktop?.storage.getItem(key) ?? localStorage.getItem(key);
  },
  setItem(key: string, value: string): void {
    if (typeof window === "undefined") { memoryStorage.set(key, value); return; }
    if (window.gameDesktop) window.gameDesktop.storage.setItem(key, value);
    else localStorage.setItem(key, value);
  },
  removeItem(key: string): void {
    if (typeof window === "undefined") { memoryStorage.delete(key); return; }
    if (window.gameDesktop) window.gameDesktop.storage.removeItem(key);
    else localStorage.removeItem(key);
  },
};
